export function legend(data: any): string {
  if (data.school.site_escola.subtitulo) {
    return data.school.site_escola.subtitulo;
  }
  return `${data.school.cidade} - ${data.school.uf}`;
}

export const PortalUtils = {
  legend,
};
